import { medicalsMedicationsQueryFilterOptions } from "../types";

export const conditionsKeys = {
  all: ["medicals", "conditions"] as const,
  conditions: (program: 'weight_loss' | 'urgent_care') => [...conditionsKeys.all, program] as const,
  condition: (id: string) => [...conditionsKeys.all, id] as const,
} as const;

export const allergiesKeys = {
  all: ["medicals", "allergies"] as const,
  allergies: (program: 'weight_loss' | 'urgent_care') => [...allergiesKeys.all, program] as const,
  allergy: (id: string) => [...allergiesKeys.all, id] as const,
} as const;

export const medicationsKeys = {
  all: ["medicals"] as const,
  medications: () => [...medicationsKeys.all] as const,
  medicationsWithFilter: (filter: medicalsMedicationsQueryFilterOptions) => [...medicationsKeys.all, filter] as const,
  activeMedications: () => [...medicationsKeys.all, "active"] as const,
  pastMedications: () => [...medicationsKeys.all, "past"] as const,
  pendingPayments: () => [...medicationsKeys.all, "pending", "payments"] as const,
  paymentHistory: (filter: medicalsMedicationsQueryFilterOptions) => [...medicationsKeys.all, "payment", "history", filter] as const,
  medication: (id1: string, id2: string) => [...medicationsKeys.medications(), id1, id2] as const,
  refills: (id1: string, id2: string) => [...medicationsKeys.medications(), id1, id2] as const,
  refill: (id?: string) => [...medicationsKeys.medications(), "refill", id] as const,
  prescription: (id?: string) => [...medicationsKeys.medications(), id] as const,
  prescriptionMedication: (prescriptionId: string, medicationId: string) => [...medicationsKeys.medications(), prescriptionId, medicationId] as const,
  prescriptions: () => [...medicationsKeys.medications(), "payment"] as const,
  medicationsHistory: (filter: medicalsMedicationsQueryFilterOptions) => [...medicationsKeys.all, "history", filter] as const,
  medicationsRefillHistory: () => [...medicationsKeys.all, "refill", "history"] as const,
  refillProcessing: () => [...medicationsKeys.all, "refill", "processing"] as const,
  medicationsSummary: (program: 'weight_loss' | 'urgent_care') => [...medicationsKeys.all, "summary", program] as const,
} as const;

